module.exports = __webpack_public_path__ + "img/milton_grove_b1.54721b8e.jpg";